// export const API_BASE_URL = "http://localhost:8080";

export const API_BASE_URL = "https://api.adanapaints.com"; 
